const baseUrl = 'https://handelsbanken.modelity.com';
const costAndChargesURL = `${baseUrl}/structures/external/public/preorder-exante-costs-and-charges`;

export const getCostAndChargesPDFURL = ({ isin }) => {
  const params = new URLSearchParams({
    // 3 = ETN
    ProductType: '3',
    IdentifierType: '1',
    Identifier: isin,
    Country: 'NO',
    Language: 'NO_no',
    Channel: '1',
    HomeCurrency: 'NOK',
    TradingCountry: 'NO',
  });

  return costAndChargesURL + '?' + params;
};
